// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mail-signature[data-v-375b1446] {\n\tfont-family: monospace;\n\topacity: 0.5;\n\tline-height: initial;\n}\n", ""]);
// Exports
module.exports = exports;
